<div class= "page page--partner-analytics">
  <div class="page__container">
    <h1 class="page__title spacing h2" translate>smsadv_send_default_title</h1>
    <div class="mt-5">
    <div ngbDropdown class="d-flex flex-column dropdown_small_device custom">
      <button class="btn btn-primary" id="dropdownAccountTab" #dropdown ngbDropdownToggle translate>common_list_tab_all</button>
      <div ngbDropdownMenu aria-labelledby="dropdownAccountTab">
        <button ngbDropdownItem translate (click)="nav.select(1); dropdown.innerText = $event.target.innerText">
          common_list_tab_all
        </button>
        <button ngbDropdownItem translate (click)="nav.select(2); dropdown.innerText = $event.target.innerText">
          smsadv_campaigns_tab_sent
        </button>
        <button ngbDropdownItem translate (click)="nav.select(3); dropdown.innerText = $event.target.innerText">smsadv_campaigns_tab_scheduled</button>
        <button ngbDropdownItem translate (click)="nav.select(4); dropdown.innerText = $event.target.innerText">smsadv_campaigns_tab_draft</button>
      </div>
    </div>
    <ul ngbNav #nav="ngbNav" class="nav-tabs nav_tab_large_device spacing custom" [(activeId)]="activeId">
      <li [ngbNavItem]="1">
        <a ngbNavLink translate>common_list_tab_all</a>
        <ng-template ngbNavContent>
          <wsb-sms-adv-list-all></wsb-sms-adv-list-all>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink translate>smsadv_campaigns_tab_sent</a>
        <ng-template ngbNavContent>
          <wsb-sms-adv-list-sent></wsb-sms-adv-list-sent>
        </ng-template>
      </li>
      <li [ngbNavItem]="3">
        <a ngbNavLink translate>smsadv_campaigns_tab_scheduled</a>
        <ng-template ngbNavContent>
          <wsb-sms-adv-list-scheduled></wsb-sms-adv-list-scheduled>
        </ng-template>
      </li>
      <li [ngbNavItem]="4">
        <a ngbNavLink translate>smsadv_campaigns_tab_draft</a>
        <ng-template ngbNavContent>
          <wsb-sms-adv-list-drafts></wsb-sms-adv-list-drafts>
        </ng-template>
      </li>
    </ul>
  </div>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
</div>

